/*function updateSelectedColor(color) {
  // Update the content of the span with id 'selectedColor'
  document.getElementById('selectedColor').innerText = color;

  // Additional logic if needed...
}*/

// Handling AJAX cart add => go to checkout
document.addEventListener('DOMContentLoaded', function () {});
/*
function updatePrice() {
  // Get values from the length and width inputs in millimeters
  console.log('updatePrice function called');

  const heightInMM = parseFloat(document.getElementById('slider3').value);
  const lengthInMM = parseFloat(document.getElementById('slider2').value);
  const widthInMM = parseFloat(document.getElementById('slider1').value);
  console.log(`Height: ${heightInMM}, Length: ${lengthInMM}, Width: ${widthInMM}`);

  const calculatedtPrice = parseFloat(document.getElementById('total-price').value);

  // Convert millimeters to meters
  const lengthInMeters = lengthInMM / 1000;
  const widthInMeters = widthInMM / 1000;
  const heightInMeters = heightInMM / 1000;

  // Constants from your formula
  const basePrice = 2249;
  const minSqm = 3;
  const pricePerSqm = 500;

  const woodBasePrice = 1240;
  const woodMinSqm = 1.5;
  const woodPricePerSqm = 100;

  const screenBasePrice = 992;
  const screenMinSqm = 1.5;
  const screenPricePerSqm = 100;

  const glassBasePrice = 1750;
  const glassMinSqm = 2.25;
  const glassPricePerSqm = 370;
  const disPr = 1;
  const disLr = 1;
  const disPl = 0.30;

  // Calculate the price
  const sqmValue = lengthInMeters * widthInMeters;
  const calculatedPrice = basePrice + ((sqmValue - minSqm) * pricePerSqm);
  console.log(`Calculated Price: ${calculatedPrice}`);

  const lrSqmValue = widthInMeters;
  const calculatedWoodPrice = findClosestWallPrice(woodBasePrice + ((lrSqmValue - woodMinSqm) * woodPricePerSqm));
  const calculatedScreenPrice = findClosestWallPrice(screenBasePrice + ((lrSqmValue - screenMinSqm) * screenPricePerSqm));
  const calculatedGlassPrice = findClosestWallPrice(glassBasePrice + ((lrSqmValue - glassMinSqm) * glassPricePerSqm));
  const fbSqmValue = lengthInMeters;
  const calculatedlWoodPrice = findClosestWallPrice(woodBasePrice + ((fbSqmValue - woodMinSqm) * woodPricePerSqm));
  const calculatedlScreenPrice = findClosestWallPrice(screenBasePrice + ((fbSqmValue - screenMinSqm) * screenPricePerSqm));
  const calculatedlGlassPrice = findClosestWallPrice(glassBasePrice + ((fbSqmValue - glassMinSqm) * glassPricePerSqm));

  // Display the calculated price in the span element
  document.getElementById('totalPrice').innerText = calculatedPrice.toFixed(0) + `${window.price_symbole} `;
  document.getElementById('woodPrice1').innerText = calculatedWoodPrice + window.price_symbole;
  document.getElementById('woodPrice2').innerText = calculatedWoodPrice + window.price_symbole;
  document.getElementById('woodPrice3').innerText = calculatedlWoodPrice + window.price_symbole;
  document.getElementById('woodPrice4').innerText = calculatedlWoodPrice + window.price_symbole;

  document.getElementById('screenPrice1').innerText = calculatedScreenPrice + window.price_symbole;
  document.getElementById('screenPrice2').innerText = calculatedScreenPrice + window.price_symbole;
  document.getElementById('screenPrice3').innerText = calculatedlScreenPrice + window.price_symbole;
  document.getElementById('screenPrice4').innerText = calculatedlScreenPrice + window.price_symbole;

  document.getElementById('glassPrice1').innerText = calculatedGlassPrice+ window.price_symbole;
  document.getElementById('glassPrice2').innerText = calculatedGlassPrice + window.price_symbole;
  document.getElementById('glassPrice3').innerText = calculatedlGlassPrice + window.price_symbole;
  document.getElementById('glassPrice4').innerText = calculatedlGlassPrice + window.price_symbole;
  document.getElementById('glassPrice5').innerText = calculatedGlassPrice + window.price_symbole;
  document.getElementById('glassPrice6').innerText = calculatedGlassPrice + window.price_symbole;
  document.getElementById('glassPrice7').innerText = calculatedlGlassPrice + window.price_symbole;
  document.getElementById('glassPrice8').innerText = calculatedlGlassPrice + window.price_symbole;

  document.getElementById('glassfixPrice1').innerText = calculatedGlassPrice + window.price_symbole;
  document.getElementById('glassfixPrice2').innerText = calculatedGlassPrice + window.price_symbole;
  document.getElementById('glassfixPrice3').innerText = calculatedlGlassPrice + window.price_symbole;
  document.getElementById('glassfixPrice4').innerText = calculatedlGlassPrice + window.price_symbole;

  // Find the closest variant based on the calculated price
  console.log("calculatedtPrice", calculatedtPrice)
  console.log("findClosestVariant", findClosestVariant(calculatedtPrice))
  const closestVariantRes = findClosestVariant(calculatedtPrice);
  console.log("closestVariantRes", closestVariantRes)

  let formattedPrice, formattedPriceE;

  if (closestVariantRes) {
    formattedPrice = (closestVariantRes.price/100).toLocaleString('de-DE');
    formattedPriceE = (closestVariantRes.price/100);
  }

  for (const priceTargets of document.querySelectorAll('.calculatedPrice')) {
    priceTargets.innerText = formattedPrice;
  }

  const disco = formattedPriceE / ((disLr - disPl) * disPr);
  
  for (const span of document.querySelectorAll('.myCheck')) {
    span.innerText = disco.toFixed(0);

    // Get the current content of the span
    const content = span.textContent;
  
    // Add a period after the first digit if the length is 4, or after the second digit if the length is 5
    let modifiedContent;

    if (content.length === 4) {
      modifiedContent = content.substring(0, 1) + '.' + content.substring(1);
    } else if (content.length === 5) {
      modifiedContent = content.substring(0, 2) + '.' + content.substring(2);
    } else {
      // Handle other cases if needed
      modifiedContent = content;
    }

    // Set the modified content back to the span
    span.textContent = modifiedContent;
  }

  for (const spans of document.querySelectorAll('.myCheckc')) {
    spans.closest('.original-price').classList.remove('hidden');
    spans.innerText = disco.toFixed(0);

    // Get the current content of the span
    const contents = spans.textContent;

    if (contents.length === 4) {
      modifiedContent = contents.substring(0, 1) + '.' + contents.substring(1);
    } else if (contents.length === 5) {
      modifiedContent = contents.substring(0, 2) + '.' + contents.substring(2);
    } else {
      // Handle other cases if needed
      modifiedContent = contents;
    }

    // Set the modified content back to the span
    spans.textContent = modifiedContent;
  }


  // Check the radio button corresponding to the closest variant
  const radioButtons = document.getElementsByName('id');
  if (closestVariantRes) {
    for (let i = 0; i < radioButtons.length; i++) {
      if (radioButtons[i].value == closestVariantRes.id) {
        radioButtons[i].checked = true;
      }
    }
  }
}

// Find Closest Value
function findClosestWallPrice(target) {
  const wallVariantValues = ['248', '496', '744', '992', '1240', '1488', '1736', '1984', '2232', '2480', '2728', '2976', '3224', '3472', '3720', '3968', '4216', '4464', '4712', '4960', '5208', '5456', '5704', '5952', '6200', '6448', '6696', '6944', '7192', '7440', '7688', '7936', '8184', '8432', '8680'];
  let closest = wallVariantValues[0];
  let smallestDiff = Math.abs(target - closest);
  wallVariantValues.forEach(num => {
    let diff = Math.abs(target - num);
    if (diff < smallestDiff) {
      smallestDiff = diff;
      closest = num;
    }
  });
  return closest;
}*/

window.debounce = function (fn, delay = 250) {
  var timer;
  var pendingPromise;
  var context;
  var args;
  var _this = this;

  return function debouncedFn() {
    context = this;
    args = arguments;

    clearTimeout(timer);

    if (pendingPromise) {
      pendingPromise.resolve();
    }

    pendingPromise = {
      promise: new Promise(function (resolve, reject) {
        timer = setTimeout(function () {
          try {
            resolve(fn.apply(context, args));
          } catch (error) {
            reject(error);

            _this._log({
              error: new Error(
                `An error occurred in Utils.debounce while executing a debounced function: ${error.message}`
              ),
            });
          }
        }, delay);
      }),
      resolve: function () {
        clearTimeout(timer);

        pendingPromise = null;
      },
    };

    return pendingPromise.promise;
  };
};
